/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 8976bd522be57bd64b1ce45436f27ede */

import { ConcreteRequest } from "relay-runtime";

export type initAutopilotQueryVariables = {
    anchors?: Array<string> | null | undefined;
};
export type initAutopilotQueryResponse = {
    readonly viewer: {
        readonly anchorLists: ReadonlyArray<{
            readonly __typename: string;
        } | null> | null;
        readonly disableAutopilotIntegration: boolean | null;
    };
};
export type initAutopilotQuery = {
    readonly response: initAutopilotQueryResponse;
    readonly variables: initAutopilotQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "anchors"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "anchors",
            "variableName": "anchors"
        } as any,
        {
            "kind": "Literal",
            "name": "listNames",
            "value": [
                "LEAD_NURTURING_BUYER_WHITELIST"
            ]
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": "disableAutopilotIntegration",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "disableAutopilotIntegration"
            }
        ],
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": "isEnabled(key:\"disableAutopilotIntegration\")"
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "initAutopilotQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "AnchorList",
                            "kind": "LinkedField",
                            "name": "anchorLists",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "initAutopilotQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "AnchorList",
                            "kind": "LinkedField",
                            "name": "anchorLists",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/initAutopilotQuery",
            "metadata": {},
            "name": "initAutopilotQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '21832c18b05b24130309ac034117d83f';
export default node;
